import React, { Fragment, useState } from "react";
import { updateCustomerBirthday } from "../../../helpers/helpers";
import { fetchCustomer } from "../../../actions/customerActions";
import { connect } from "react-redux";

const BirthdayItem = ({
  imgUrl,
  title,
  desc,
  isButton = false,
  disabled = true,
  buttonText = "Redeem",
  onClickHandler,
  appStateData,
  customerData,
  note = "",
}) => {
  let { shopDomain, customerId } = appStateData;
  let { customer } = customerData;
  const [isSecondPage, setIsSecondPage] = useState(false);
  const [value, setValue] = useState(false);

  return (
    <div
      onClick={() =>
        disabled && !isSecondPage && setIsSecondPage((prev) => !prev)
      }
      className="waysToEarn-item-container"
    >
      {!isSecondPage ? (
        <Fragment>
          <div className="waysToEarn-item-image-container">
            <img src={imgUrl} alt="icon" />
          </div>
          <div className="waysToEarn-item-text-container">
            <p className="waysToEarn-item-text">{title}</p>
            <p
              style={{
                fontSize: "10px",
                paddingInline: "2px",
                textAlign: "center",
                minHeight: "14px",
              }}
            >
              {note ? `(*${note})` : ""}
            </p>
          </div>
          <div className="waysToEarn-item-details-container">
            <span className="waysToEarn-item-details">{desc}</span>

            <button
              style={{
                visibility: !isButton ? "hidden" : "visible",
              }}
              disabled={!disabled}
              onClick={() => setIsSecondPage((prev) => !prev)}
              className="waysToEarn-item-button"
            >
              {buttonText}
            </button>
          </div>
        </Fragment>
      ) : (
        <div className="birthdayItem-detail-page-wrapper">
          <div className="birthdayItem-input-container">
            <h3 className="birthdayItem-input-text">Select your birthbay</h3>
            <input
              className="birthdayItem-input"
              value={value}
              type="date"
              onChange={(e) => setValue(e.target.value)}
            />
          </div>

          {/* save button  */}
          <div className="birthdayItem-save-btn-container">
            <button
              className="birthdayItem-save-btn"
              disabled={!value}
              onClick={async () => {
                let birthday = new Date(value);
                await updateCustomerBirthday(
                  shopDomain,
                  customerId,
                  birthday.getDate(),
                  birthday.getMonth() + 1
                );
                await fetchCustomer(customerId, shopDomain);
                setIsSecondPage((prev) => !prev);
              }}
            >
              Save
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  customerData: state.CustomerReducer,
  merchantData: state.MerchantReducer,
  appStateData: state.AppstateReducer,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCustomer: (customerId, shopDomain) =>
    dispatch(fetchCustomer(customerId, shopDomain)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BirthdayItem);
